import { PackageInspectorShow } from "@/resources/packages/PackageInspectorShow";

/**
 * Frame detail — the shared Inspector grammar over a `package_type='frame'`
 * record (overview, body, package links, audit). Compile is the primary action.
 */
export function FrameShow() {
  return (
    <PackageInspectorShow
      resource="frames"
      dataResource="packages"
      expectType="frame"
      label="Frame"
      subtitle="A framing package that shapes bets and constrains how work is interpreted."
    />
  );
}

export default FrameShow;
